var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return render
    ? _c(
        "v-snackbar",
        {
          ref: "vSnack",
          style: { color: _vm.snackbarTheme === "warning" ? "black" : "white" },
          attrs: {
            color: _vm.snackbarTheme,
            timeout: _vm.timeout,
            top: _vm.top,
            bottom: _vm.bottom,
            right: _vm.snackbarX === "right",
            left: _vm.snackbarX === "left",
            "multi-line": _vm.snackbarMode === "multi-line",
            vertical: _vm.snackbarMode === "vertical",
            "auto-height": true
          },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.snackbarText) } }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              style: {
                color: _vm.snackbarTheme === "warning" ? "black" : "white"
              },
              attrs: { flat: "" },
              nativeOn: {
                click: function($event) {
                  return _vm.clicked($event)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("global.close")))]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-230ef104", { render: render, staticRenderFns: staticRenderFns })
  }
}